"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentingStatus = void 0;
var RentingStatus;
(function (RentingStatus) {
    RentingStatus["FailedNotEnoughBalance"] = "failed_not_enough_balance";
    RentingStatus["FailedNotGetClaimKey"] = "failed_not_get_claim_key";
    RentingStatus["FailedNotGetRecaptchaToken"] = "failed_not_get_recaptcha_token";
    RentingStatus["FailedUnlistedOrSoldOut"] = "failed_unlisted_or_soldout";
    RentingStatus["FailedRented"] = "failed_rented";
    RentingStatus["Success"] = "success";
})(RentingStatus = exports.RentingStatus || (exports.RentingStatus = {}));
